import React from 'react';
import { Link } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

const PrivacyPolicy = () => {
	return (
		<div style={{ 
			minHeight: '100vh', 
			background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)',
			paddingTop: '70px',
			paddingBottom: '70px'
		}}>
			{/* Top Navbar */}
			<Navbar expand="sm" fixed="top" style={{ 
				background: 'rgba(255, 255, 255, 0.95)',
				backdropFilter: 'blur(10px)',
				boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
			}}>
				<Link to="/" style={{ marginLeft: '1rem' }}>
					<img src="/images/p10.jpg" alt="Logo" style={{ height: '40px', borderRadius: '8px' }} />
				</Link>
				<Nav className="ml-auto" style={{ marginRight: '1rem' }}>
					<Link to="/about" style={{ 
						color: '#1e3a8a', 
						textDecoration: 'none',
						fontWeight: '600',
						marginLeft: '1.5rem'
					}}>
						About
					</Link>
				</Nav>
			</Navbar>

			{/* Main Content */}
			<div style={{ 
				display: 'flex', 
				justifyContent: 'center', 
				alignItems: 'center',
				minHeight: 'calc(100vh - 140px)',
				padding: '40px 20px'
			}}>
				<div style={{ 
					maxWidth: '900px',
					width: '100%',
					background: 'white',
					borderRadius: '20px',
					padding: '3rem',
					boxShadow: '0 15px 50px rgba(0,0,0,0.25)'
				}}>
					<h1 style={{ 
						fontSize: '2.5rem',
						fontWeight: '700',
						marginBottom: '0.5rem',
						color: '#1e3a8a',
						textAlign: 'center'
					}}>
						Privacy Policy
					</h1>
					<p style={{ 
						textAlign: 'center', 
						color: '#718096',
						marginBottom: '2rem',
						fontSize: '1.1rem'
					}}>
						Last updated: January 19, 2025
					</p>
					
					<div style={{ 
						color: '#4a5568',
						lineHeight: '1.8',
						fontSize: '1rem'
					}}>
						<p style={{ marginBottom: '1.5rem' }}>
							This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Interpretation and Definitions
						</h2>

						<h3 style={{ 
							fontSize: '1.4rem',
							fontWeight: '600',
							marginTop: '1.5rem',
							marginBottom: '0.75rem',
							color: '#2563eb'
						}}>
							Interpretation
						</h3>
						<p style={{ marginBottom: '1.5rem' }}>
							The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
						</p>

						<h3 style={{ 
							fontSize: '1.4rem',
							fontWeight: '600',
							marginTop: '1.5rem',
							marginBottom: '0.75rem',
							color: '#2563eb'
						}}>
							Definitions
						</h3>
						<p style={{ marginBottom: '1rem' }}>For the purposes of this Privacy Policy:</p>
						<ul style={{ 
							marginBottom: '1.5rem',
							paddingLeft: '1.5rem',
							lineHeight: '2'
						}}>
							<li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
							<li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to p10 rating.</li>
							<li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
							<li><strong>Country</strong> refers to: Texas, United States</li>
							<li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
							<li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
							<li><strong>Service</strong> refers to the Website.</li>
							<li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</li>
							<li><strong>Third-party Social Media Service</strong> refers to any website or any social network website through which a User can log in or create an account to use the Service.</li>
							<li><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</li>
							<li><strong>Website</strong> refers to p10 rating, accessible from <a href="https://www.p10rating.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6' }}>https://www.p10rating.com/</a></li>
							<li><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
						</ul>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Collecting and Using Your Personal Data
						</h2>

						<h3 style={{ 
							fontSize: '1.4rem',
							fontWeight: '600',
							marginTop: '1.5rem',
							marginBottom: '0.75rem',
							color: '#2563eb'
						}}>
							Types of Data Collected
						</h3>

						<h4 style={{ 
							fontSize: '1.2rem',
							fontWeight: '600',
							marginTop: '1.25rem',
							marginBottom: '0.5rem',
							color: '#3b82f6'
						}}>
							Personal Data
						</h4>
						<p style={{ marginBottom: '1rem' }}>
							While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
						</p>
						<ul style={{ 
							marginBottom: '1.5rem',
							paddingLeft: '1.5rem',
							lineHeight: '2'
						}}>
							<li>Email address</li>
							<li>First name and last name</li>
							<li>Usage Data</li>
						</ul>

						<h4 style={{ 
							fontSize: '1.2rem',
							fontWeight: '600',
							marginTop: '1.25rem',
							marginBottom: '0.5rem',
							color: '#3b82f6'
						}}>
							Usage Data
						</h4>
						<p style={{ marginBottom: '1rem' }}>
							Usage Data is collected automatically when using the Service.
						</p>
						<p style={{ marginBottom: '1rem' }}>
							Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
						</p>
						<p style={{ marginBottom: '1rem' }}>
							When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.
						</p>

						<h4 style={{ 
							fontSize: '1.2rem',
							fontWeight: '600',
							marginTop: '1.25rem',
							marginBottom: '0.5rem',
							color: '#3b82f6'
						}}>
							Tracking Technologies and Cookies
						</h4>
						<p style={{ marginBottom: '1rem' }}>
							We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:
						</p>
						<ul style={{ 
							marginBottom: '1.5rem',
							paddingLeft: '1.5rem',
							lineHeight: '2'
						}}>
							<li><strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies.</li>
							<li><strong>Flash Cookies.</strong> Certain features of our Service may use local stored objects (or Flash Cookies) to collect and store information about Your preferences or Your activity on our Service. Flash Cookies are not managed by the same browser settings as those used for Browser Cookies.</li>
							<li><strong>Web Beacons.</strong> Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics.</li>
						</ul>
						<p style={{ marginBottom: '1rem' }}>
							Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser.
						</p>
						<p style={{ marginBottom: '1rem' }}>
							We use both Session and Persistent Cookies for the purposes set out below:
						</p>
						<ul style={{ 
							marginBottom: '1.5rem',
							paddingLeft: '1.5rem',
							lineHeight: '2'
						}}>
							<li>
								<strong>Necessary / Essential Cookies</strong><br/>
								Type: Session Cookies<br/>
								Administered by: Us<br/>
								Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.
							</li>
							<li>
								<strong>Cookies Policy / Notice Acceptance Cookies</strong><br/>
								Type: Persistent Cookies<br/>
								Administered by: Us<br/>
								Purpose: These Cookies identify if users have accepted the use of cookies on the Website.
							</li>
							<li>
								<strong>Functionality Cookies</strong><br/>
								Type: Persistent Cookies<br/>
								Administered by: Us<br/>
								Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.
							</li>
						</ul>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Use of Your Personal Data
						</h2>
						<p style={{ marginBottom: '1rem' }}>The Company may use Personal Data for the following purposes:</p>
						<ul style={{ 
							marginBottom: '1.5rem',
							paddingLeft: '1.5rem',
							lineHeight: '2'
						}}>
							<li><strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.</li>
							<li><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.</li>
							<li><strong>For the performance of a contract:</strong> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.</li>
							<li><strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.</li>
							<li><strong>To provide You</strong> with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.</li>
							<li><strong>To manage Your requests:</strong> To attend and manage Your requests to Us.</li>
							<li><strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.</li>
							<li><strong>For other purposes:</strong> We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.</li>
						</ul>

						<p style={{ marginBottom: '1rem' }}>We may share Your personal information in the following situations:</p>
						<ul style={{ 
							marginBottom: '1.5rem',
							paddingLeft: '1.5rem',
							lineHeight: '2'
						}}>
							<li><strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.</li>
							<li><strong>For business transfers:</strong> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.</li>
							<li><strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.</li>
							<li><strong>With business partners:</strong> We may share Your information with Our business partners to offer You certain products, services or promotions.</li>
							<li><strong>With other users:</strong> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.</li>
							<li><strong>With Your consent:</strong> We may disclose Your personal information for any other purpose with Your consent.</li>
						</ul>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Retention of Your Personal Data
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Transfer of Your Personal Data
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.
						</p>
						<p style={{ marginBottom: '1rem' }}>
							Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Disclosure of Your Personal Data
						</h2>

						<h3 style={{ 
							fontSize: '1.4rem',
							fontWeight: '600',
							marginTop: '1.5rem',
							marginBottom: '0.75rem',
							color: '#2563eb'
						}}>
							Business Transactions
						</h3>
						<p style={{ marginBottom: '1.5rem' }}>
							If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
						</p>

						<h3 style={{ 
							fontSize: '1.4rem',
							fontWeight: '600',
							marginTop: '1.5rem',
							marginBottom: '0.75rem',
							color: '#2563eb'
						}}>
							Law enforcement
						</h3>
						<p style={{ marginBottom: '1.5rem' }}>
							Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
						</p>

						<h3 style={{ 
							fontSize: '1.4rem',
							fontWeight: '600',
							marginTop: '1.5rem',
							marginBottom: '0.75rem',
							color: '#2563eb'
						}}>
							Other legal requirements
						</h3>
						<p style={{ marginBottom: '1rem' }}>
							The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
						</p>
						<ul style={{ 
							marginBottom: '1.5rem',
							paddingLeft: '1.5rem',
							lineHeight: '2'
						}}>
							<li>Comply with a legal obligation</li>
							<li>Protect and defend the rights or property of the Company</li>
							<li>Prevent or investigate possible wrongdoing in connection with the Service</li>
							<li>Protect the personal safety of Users of the Service or the public</li>
							<li>Protect against legal liability</li>
						</ul>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Security of Your Personal Data
						</h2>
						<p style={{ marginBottom: '1.5rem' }}>
							The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Links to Other Websites
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Changes to this Privacy Policy
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.
						</p>
						<p style={{ marginBottom: '1rem' }}>
							We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Contact Us
						</h2>
						<p style={{ marginBottom: '0' }}>
							If you have any questions about this Privacy Policy, You can contact us:
						</p>
						<ul style={{ 
							paddingLeft: '1.5rem',
							lineHeight: '2'
						}}>
							<li>By email: <a href="mailto:info@p10rating.com" style={{ color: '#3b82f6' }}>admin@p10rating.com</a></li>
						</ul>
					</div>
				</div>
			</div>

			{/* Bottom Navbar */}
			<Navbar fixed="bottom" style={{ 
				background: 'rgba(255, 255, 255, 0.95)',
				backdropFilter: 'blur(10px)',
				boxShadow: '0 -2px 20px rgba(0,0,0,0.1)',
				padding: '1rem'
			}}>
				<Nav style={{ 
					width: '100%', 
					display: 'flex', 
					justifyContent: 'center',
					flexWrap: 'wrap',
					gap: '0.5rem'
				}}>
					<span style={{ margin: '0 0.5rem', color: '#4a5568', fontWeight: '500' }}>
						p10rating © 2026
					</span>
					<Link to='/terms' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
						Terms
					</Link>
					<Link to='/disclaimer' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
						Disclaimer
					</Link>
					<Link to='/about' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
						About
					</Link>
					<Link to='/' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
						Sign In
					</Link>
				</Nav>
			</Navbar>
		</div>
	);
}

export default PrivacyPolicy;